<template>
  <div class="login-page">
    <v-row class="login-row">
      <v-col cols="12" md="8" class="login-image-col">
        <v-img class="login-image" src="@/assets/Login.png" contain></v-img>
      </v-col>
      <v-col cols="12" md="4" class="login-form-col">
        <v-card elevation="0" color="#001a33" class="card-login">
          <v-card-title>
            <v-row>
              <v-col>
                <v-btn block class="title-color" elevation="0" rounded color="#c5e2c5" @click="loginType = 'email'">
                  ایمیل
                </v-btn>
              </v-col>
              <v-col>
                <v-btn block class="title-color" elevation="0" rounded color="#c5e2c5" @click="loginType = 'phone'">
                  شماره همراه
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="card-login-body">
            <v-row>
              <v-checkbox @change="changeLogin()" color="#f0b600" label="ورود به عنوان مدیریت"
                          v-model="isAdmin"></v-checkbox>
            </v-row>
            <v-row v-if="loginType === 'phone'">
              <v-col cols="12" v-if="waitForOtp">
                <v-text-field type="tel" color="#001a33" label="شماره همراه"
                              v-model="credentials.phone"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="waitForOtp">
                <v-btn block class="main-btn-login" elevation="0" rounded color="#f0b600" @click="getOtp()">دریافت کد
                  تایید
                </v-btn>
              </v-col>

              <v-col cols="12" v-if="!waitForOtp">
                <v-text-field type="number" color="#001a33" label="کد را وارد کنید."
                              v-model="credentials.code"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="!waitForOtp">
                <v-btn block class="main-btn-login" elevation="0" rounded color="#f0b600" @click="loginWithOtp()">ورود
                  ورود
                </v-btn>
              </v-col>

            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <v-text-field color="#001a33" label="ایمیل"
                              v-model="credentials.email"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field type="password" color="#001a33" label="رمز عبور"
                              v-model="credentials.password"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn block class="main-btn-login" elevation="0" rounded color="#f0b600" @click="loginWithEmail()">ورود
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {
      isAdmin: false,
      loginType: null,
      waitForOtp: true,
      credentials: {
        email: null,
        phone: null,
        password: null,
        code: null
      }
    }
  },
  mounted() {

  },
  methods: {
    changeLogin() {

    },
    async getOtp() {
      if (this.isAdmin) {
        await window.axios.post('admin/auth/otp/get', {
          mobile: this.credentials.phone
        }).then((res) => {
          this.waitForOtp = false
          this.openSnackbar(res.data.message, 'success')
        })
      } else {
        await window.axios.post('instructor/auth/otp/get', {
          mobile: this.credentials.phone
        }).then((res) => {
          this.waitForOtp = false
          this.openSnackbar(res.data.message, 'success')
        })
      }
    },
    async loginWithOtp() {
      if (this.isAdmin) {
        await window.axios.post('admin/auth/otp/verify', {
          mobile: this.credentials.phone,
          code: this.credentials.code
        }).then((res) => {
          this.$cookies.set('userType', 'admin')
          this.$store.state.user = res.data.data.user
          this.$store.state.auth = true
          this.$cookies.set('token', 'Bearer ' + res.data.data.token)
          this.$router.go(0)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.showValidationErrors(err, '#F1416C')
          } else if (err.response.status === 400 || err.response.status === 404 || err.response.status === 403) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          }
        })
      } else {
        await window.axios.post('instructor/auth/otp/verify', {
          mobile: this.credentials.phone,
          code: this.credentials.code
        }).then((res) => {
          this.$cookies.set('userType', 'instructor')
          this.$store.state.user = res.data.data.user
          this.$store.state.auth = true
          this.$cookies.set('token', 'Bearer ' + res.data.data.token)
          this.$router.go(0)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.showValidationErrors(err, '#F1416C')
          } else if (err.response.status === 400 || err.response.status === 404 || err.response.status === 403) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          }
        })
      }
    },
    async loginWithEmail() {
      if (this.isAdmin) {
        await window.axios.post('admin/auth/email/login', {
          email: this.credentials.email,
          password: this.credentials.password
        }).then((res) => {
          this.$cookies.set('userType', 'admin')
          this.$store.state.user = res.data.data.user
          this.$store.state.auth = true
          this.$cookies.set('token', 'Bearer ' + res.data.data.token)
          this.$router.go(0)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.showValidationErrors(err, '#F1416C')
          } else if (err.response.status === 400 || err.response.status === 404 || err.response.status === 403) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          }
        })
      } else {
        await window.axios.post('instructor/auth/email/login', {
          email: this.credentials.email,
          password: this.credentials.password
        }).then((res) => {
          this.$cookies.set('userType', 'instructor')
          this.$store.state.user = res.data.data.user
          this.$store.state.auth = true
          this.$cookies.set('token', 'Bearer ' + res.data.data.token)
          this.$router.go(0)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.showValidationErrors(err, '#F1416C')
          } else if (err.response.status === 400 || err.response.status === 404 || err.response.status === 403) {
            this.openSnackbar(err.response.data.message, '#F1416C')
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.card-login {
  border-color: #f0b600 !important;
  border-style: solid !important;
  border-width: 2px !important;
  border-radius: 15px !important;
  margin-top: 12vh !important;
  max-width: 480px;
  width: 100%;
}

.title-color {
  border-color: #f0b600 !important;
  border-style: solid !important;
  border-width: 2px !important;
  color: #001a33 !important;
  margin-bottom: 10px !important;
  letter-spacing: normal !important;
}

.card-login-body {
  background-color: #e2e8ed !important;
}

.main-btn-login {
  letter-spacing: normal !important;
  border-color: #001a33 !important;
  border-style: solid !important;
  border-width: 2px !important;
}

.login-page {
  min-height: 100vh;
  padding: 16px;
}

.login-row {
  min-height: calc(100vh - 32px);
  align-items: center;
}

.login-image-col,
.login-form-col {
  display: flex;
  justify-content: center;
}

.login-image {
  max-height: 78vh;
  width: 100%;
}

@media (max-width: 960px) {
  .card-login {
    margin-top: 0 !important;
  }

  .login-page {
    padding: 12px;
  }

  .login-row {
    min-height: auto;
  }

  .login-image-col {
    order: 2;
    margin-top: 12px;
  }

  .login-form-col {
    order: 1;
  }

  .login-image {
    max-height: 34vh;
  }
}
</style>
